import React, { Component, Children } from 'react';
import Container from '../../components/Container';
import { Grid, Checkbox,List, ListItem,ListItemIcon, Radio, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { BackOnPrimaryIcon, PlaceActiveIcon, ArrowRightIcon, ArrowDownIcon } from '../../components/icons';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelect, SelectComponent} from '../../components/FormElement';
import validators from '../../utils/validators';
import ButtonCustom from '../../components/ButtonCustom';
import {address_types} from '../../../portal.config'
import {addressCountries} from '../../../portal.menu.config'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { getCountries, getCountryDefault } from '../../utils/common';
const styles = theme => ({
    bg_type_address: {
        padding: theme.spacing(1,3,1,3),
        borderRadius: theme.spacing(4),
        borderWidth: 1,
        backgroundColor: theme.palette.success.light,
        borderColor: theme.palette.border.success,
    },
    select_address:{
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        marginTop: theme.spacing(1),
        cursor: 'pointer'
    },
    icon: {
        borderRadius: 4,
        width: 18,
        height: 18,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
          outline: '2px auto rgba(19,124,189,.6)',
          outlineOffset: 2,
        },
        'input:hover ~ &': {
          backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
          boxShadow: 'none',
          background: 'rgba(206,217,224,.5)',
        },
      },
      checkedIcon: {
        borderRadius: 4,
        backgroundColor: theme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
          display: 'block',
          width: 18,
          height: 18,
          
          backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
          content: '""',
        },
        'input:hover ~ &': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    button_save: {
        marginTop: theme.spacing(4)
    },
});
function CurrentLocationView(props) {

    const {classes, t, address_info, onSubmit, showLoading, mode, onSelectTypeAddress, not_support_region} = props
    //console.log('AddAddressesView address_info==',address_info)
    return (
        <div>
            <DrawerCustom 
                open={props.open} 
                onClose={props.onClose}
                title = {t('current_location')}
                enableBack
                children={<Grid item>
                    <Grid xs={12} item container justify='center'>
                        {showLoading?<CustomizedCircularProgress/>:null}
                    </Grid>
                        <Form
                                    onSubmit={onSubmit}
                                    render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                        <Grid xs={12} container item  justify='center' className={classes.marginTop}>
                                            
                                                <Grid item> 
                                                <Grid xs={12} item container>
                                                    <Field
                                                        name="address_line_1"
                                                        component={TextFieldComponent}
                                                        label={t('address_line')+' 1'} 
                                                        defaultValue={address_info&&address_info.address_line_1?address_info.address_line_1:null}
                                                        isEdit={mode==='add'?true:false}
                                                        color='default'
                                                        validate={validators.composeValidators(validators.required)}
                                                    />
                                                </Grid>
                                                <Grid xs={12} item container>
                                                    <Field
                                                        name="address_line_2"
                                                        component={TextFieldComponent}
                                                        label={t('address_line')+' 2'}
                                                        defaultValue={address_info&&address_info.address_line_2?address_info.address_line_2:null}
                                                        isEdit={mode==='add'?true:false}
                                                        color='default'
                                                    />
                                                </Grid>
                                                <Grid xs={12} item container>
                                                    <Grid xs={12} sm ={5} item container justify='flex-start'>
                                                        <Field
                                                            name="city"
                                                            component={TextFieldComponent}
                                                            label={t('city')}
                                                            defaultValue={address_info&&address_info.town_city?address_info.town_city:null}
                                                            // isEdit={mode==='add'?true:false}
                                                            isEdit={false}
                                                            color='default'
                                                            //validate={validators.composeValidators(validators.required)}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={2}></Grid>
                                                    <Grid xs={12} sm={5} item container justify='flex-end'>
                                                        <Field
                                                            name="postal_code"
                                                            component={TextFieldComponent}
                                                            label={t('postal_code')}
                                                            defaultValue={address_info&&address_info.postal_code?address_info.postal_code:null}
                                                            //isEdit={mode==='add'?true:false}
                                                            isEdit={true}
                                                            color='default'
                                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                                        />
                                                    </Grid>                                  
                                                </Grid>
                                                <Grid xs={12} item container>
                                                    <Grid xs={12} sm={5}item container justify='flex-start'>
                                                        <Field
                                                            name="state"
                                                            component={TextFieldComponent}
                                                            label={t('state')}
                                                            defaultValue={address_info&&address_info.state_province_county?address_info.state_province_county:null}
                                                            // isEdit={mode==='add'?true:false}
                                                            isEdit={false}
                                                            color='default'
                                                            //validate={validators.composeValidators(validators.required)}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={2}></Grid>
                                                    <Grid xs={12} sm={5} item container justify='flex-end'>
                                                        <Field
                                                            name="country_code"
                                                            component={SelectComponent}
                                                            label={t('country')}
                                                            selectData={getCountries()}
                                                            defaultValueSelect={address_info && address_info.country_code ? address_info && address_info.country_code : (getCountryDefault() ? getCountryDefault().value : null)}
                                                            valueSelect={address_info&&address_info.country_code?address_info.country_code:addressCountries[0].value}
                                                            onSelectedChange={(event)=>props.onHandleChange('country_code',event.target.value)}
                                                            color='default'
                                                            placeholder = {t('Select')}
                                                            //isEdit={mode==='add'?true:false}
                                                            isEdit={!(address_info && address_info.country_code && props.isDisableCountryField)}
                                                        />
                                                    </Grid>                                  
                                                </Grid>
                                                <Grid xs={12} item container justify='center' className={classes.button_save}>
                                                    <ButtonCustom color='primary' fullWidth disabled={not_support_region} onClick={handleSubmit}>{t('set_current_location')}</ButtonCustom>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )} />
                </Grid>}/>
    </div>
    );
}


export default withStyles(styles)(withTranslation()(CurrentLocationView));